/**
 * =============================================================================
 * product-models.js
 * =============================================================================
 * Provide support for 3D product models, based on Dawn <product-model> Custom
 * Element
 * =============================================================================
 */
 var ProductModels = {

  uis: [],

  init: function() {
    let productModelContainers = document.querySelectorAll(".product-model");
    var that = this;
    productModelContainers.forEach(element => {
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: that.setupModelViewerUI.bind(that, element.querySelector('model-viewer')),
        },
      ]);
    });

    window.ProductModel = {
      loadShopifyXR() {
        Shopify.loadFeatures([
          {
            name: 'shopify-xr',
            version: '1.0',
            onLoad: this.setupShopifyXR.bind(this),
          },
        ]);
      },
    
      setupShopifyXR(errors) {
        if (errors) return;
    
        if (!window.ShopifyXR) {
          document.addEventListener('shopify_xr_initialized', () =>
            this.setupShopifyXR()
          );
          return;
        }
    
        document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
          window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
          modelJSON.remove();
        });
        window.ShopifyXR.setupXRElements();
      },
    };
    
    window.ProductModel?.loadShopifyXR();
  },

  setupModelViewerUI: function(modelViewerElement) {
    let ui = new Shopify.ModelViewerUI(modelViewerElement);
    this.uis.push(ui);
  }
}

export default ProductModels;